import React from "react";
import { Row, Col, Typography, Button } from 'antd';

// ICONS
import { IoAlbums, IoApps, IoArrowBackCircle, IoBusiness, IoClipboard, IoCloseCircle, IoGrid, IoMap, IoPeople, IoMan, IoSettings, IoIdCard, IoCalendar, IoDocument, IoBook, IoCalculator, IoPerson, IoCard, IoInformation, IoDocumentText } from "react-icons/io5";
import { RiGraduationCapFill } from "react-icons/ri";
import { Link } from "react-router-dom";

class AgenciaMenu extends React.Component {

    state = { selected: null, title: '' }

    render = () => {

        const { onMenu } = this.props

        if (this.props.type === 'pc') {
            return (
                <Row gutter={[8,8]} justify={'center'}>
                    <Col xs={24}>
                        <Link to="agenda"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoCalendar className="menu-button-icon" />Agenda</Button></Link>
                    </Col>
                    <Col xs={24}>
                        <Link to="reuniao"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoPerson className="menu-button-icon" />Reunião Atendimento</Button></Link>
                    </Col>
                    <Col xs={24}>
                        <Link to="apresentação"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoBook className="menu-button-icon" />Apresentação Comercial</Button></Link>
                    </Col>
                </Row>
            )
        }

        if (this.props.type === 'app') {
            return (
                <Row gutter={[16,16]} justify={'center'}>
                    <Col xs={24} style={{display: 'flex', alignItems: 'center'}}>
                        <Button key={'back'} onClick={onMenu} type="link" shape="circle" style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}><IoCloseCircle size={28} color="var(--fourth)" /></Button><Typography className="menu-text">Menu</Typography>
                    </Col>
                    <Col xs={12}>
                        <Link to="agenda"><Button onClick={onMenu} type="link" shape="round" block className="menu-button"><IoCalendar className="menu-button-icon" />Agenda</Button></Link>
                    </Col>
                    <Col xs={12}>
                        <Link to={'reuniao'} onClick={onMenu}><Button type="link" shape="round" block className="menu-button"><IoPerson className="menu-button-icon" />Reunião Atend.</Button></Link>
                    </Col>
                    <Col xs={12}>
                        <Link to={'apresentação'} onClick={onMenu}><Button type="link" shape="round" block className="menu-button"><IoBook className="menu-button-icon" />Apres. Comercial</Button></Link>
                    </Col>
                </Row>
            )
        }

    }

}

export default AgenciaMenu;